// @flow
import React, { useEffect, useRef, useState } from 'react';
import DefaultTheme from './theme';
export var PanelTheme = DefaultTheme;
/*::
import type { Node } from 'react';
import type { StyledComponent } from 'styled-components';

export type ThemeType = {|
  Main: * => StyledComponent,
  Head: * => StyledComponent,
  Body: * => StyledComponent,
  Content: * => StyledComponent,
|};

type Props = {|
  isActive: boolean,
  head: Node | Array<Node>,
  body: Node | Array<Node>,
  activatePanel: () => void,
  recalculateHeight?: boolean,
  scrollTo?: boolean,
  theme?: ThemeType
|}
*/

var Panel = function Panel(_ref
/*: Props */
) {
  var isActive = _ref.isActive,
      head = _ref.head,
      body = _ref.body,
      activatePanel = _ref.activatePanel,
      recalculateHeight = _ref.recalculateHeight,
      _ref$scrollTo = _ref.scrollTo,
      scrollTo = _ref$scrollTo === void 0 ? false : _ref$scrollTo,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme;

  var _useState = useState(0),
      height = _useState[0],
      setHeight = _useState[1];

  var mainRef = useRef();
  var bodyRef = useRef();
  useEffect(function () {
    var getHeight = setTimeout(function () {
      if (bodyRef && bodyRef.current) {
        var scrollHeight = bodyRef.current.scrollHeight;
        setHeight(scrollHeight);
      }
    }, 333);
    return function () {
      clearTimeout(getHeight);
    };
  }, [recalculateHeight]);
  useEffect(function () {
    var scrollTimeout = setTimeout(function () {
      if (scrollTo && mainRef && mainRef.current) {
        mainRef.current.scrollIntoView();
      }
    }, 800);
    return function () {
      clearTimeout(scrollTimeout);
    };
  }, [scrollTo]);
  return /*#__PURE__*/React.createElement(theme.Main, {
    ref: mainRef,
    role: "tab",
    "aria-expanded": isActive
  }, /*#__PURE__*/React.createElement(theme.Head, {
    onClick: activatePanel
  }, head), /*#__PURE__*/React.createElement(theme.Body, {
    "aria-hidden": !isActive,
    ref: bodyRef,
    heightProp: (isActive ? height : 0) + "px"
  }, /*#__PURE__*/React.createElement(theme.Content, {
    visible: isActive
  }, body)));
};

export default Panel;